/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Rest_Hr_HintInputs */

const en_ui_onboarding_rest_hr_hint = /** @type {(inputs: Ui_Onboarding_Rest_Hr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowest value, e.g. right after waking up`)
};

const de_ui_onboarding_rest_hr_hint = /** @type {(inputs: Ui_Onboarding_Rest_Hr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedrigster Wert, z. B. direkt nach dem Aufwachen`)
};

/**
* | output |
* | --- |
* | "Lowest value, e.g. right after waking up" |
*
* @param {Ui_Onboarding_Rest_Hr_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_rest_hr_hint = /** @type {((inputs?: Ui_Onboarding_Rest_Hr_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Rest_Hr_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_rest_hr_hint(inputs)
	return de_ui_onboarding_rest_hr_hint(inputs)
});